"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  ref: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: (0, _propTypes.instanceOf)(Element)
  })]),
  backgroundColor: _propTypes.string,
  color: _propTypes.string,
  direction: _propTypes.string,
  icon: _propTypes.node,
  lastStep: _propTypes.bool,
  lineStyle: _propTypes.string,
  variant: _propTypes.string
} : {};
const defaultProps = {
  component: 'div',
  direction: 'horizontal',
  variant: 'active'
};

const Step = ({
  'data-testid': testId,
  ref,
  backgroundColor,
  className,
  color,
  component,
  direction,
  icon,
  lastStep,
  lineStyle,
  variant,
  ...other
}) => (0, _core.jsx)(_components.StepWrapper, (0, _extends2.default)({
  lastStep: lastStep,
  direction: direction,
  as: component,
  ref: ref,
  className: className,
  "data-testid": testId
}, other), (0, _core.jsx)(_components.Bullet, {
  icon: icon,
  backgroundColor: backgroundColor,
  color: color,
  variant: variant,
  direction: direction
}, icon), (0, _core.jsx)(_components.Line, {
  color: color,
  variant: variant,
  direction: direction,
  lastStep: lastStep,
  lineStyle: lineStyle
}));

process.env.NODE_ENV !== "production" ? Step.propTypes = propTypes : void 0;
Step.defaultProps = defaultProps;
const WithForwardRef = (0, _utils.withForwardRef)(Step);
exports.Step = WithForwardRef;